export default __webpack_public_path__ + "./images/tl.40aab987.png";